import { render, staticRenderFns } from "./AddSocialProfileDialog.vue?vue&type=template&id=43885fd5"
import script from "./AddSocialProfileDialog.vue?vue&type=script&lang=js"
export * from "./AddSocialProfileDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports